<kendo-listview [data]="alerts" containerClass="k-d-flex k-flex-col k-flex-nowrap">
  <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
    <div class="alert" [class.border-top]="borderTop">

      <div class="alert-details">
        <div>
          <span>{{ dataItem.name }}</span>
          <span>{{ dataItem.info }}</span>
          <span>
            <kendo-icon name="eye" size="large"></kendo-icon>
          </span>
        </div>
        <div>
          <span>{{ dataItem.nycid }}</span>
          <span>Due: {{ dataItem.date | date : 'MM/dd/yyyy' }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</kendo-listview>